/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { uiSchemaProperties } from 'shared/enums/uiSchemaProperties';

const useStyles = makeStyles({
  root: { marginBottom: '3rem' },
});

export default function FormSectionField(props) {
  const { idSchema, registry } = props;
  const ObjectField = registry?.fields?.ObjectField;
  const classes = useStyles();
  const hidden = props.uiSchema[uiSchemaProperties.UI_HIDDEN];
  const noBottomSpacing = props.uiSchema[uiSchemaProperties.UI_NO_BOTTOM_SPACING];
  return hidden ? null : (
    <div className={!noBottomSpacing && classes.root} name={idSchema.$id} id={idSchema.$id}>
      <ObjectField {...props} />
    </div>
  );
}
